import React from 'react';
import styled from 'styled-components';
export const DividerWrapper = styled.div `
  width: 100%;
  height: 15px;
  background: transparent;
  border-top: 1px dashed #dfdfdf;
`;
export const Divider = () => {
    return React.createElement(DividerWrapper, null);
};
//# sourceMappingURL=index.js.map